module.exports = __webpack_public_path__ + "img/5_79.116d9d04.png";